module.exports = __webpack_public_path__ + "media/images/resource-types/doc-6804fc5a88f0bccccb6ba631a0607dda.svg";